import profile from '../../Assets/Images/Artists/05/profile_hidden.jpg'
import mosaic1Img from '../../Assets/Images/Artists/05/projects/01/mosiac1.png'

const project1 = {
  title: 'Mosaic 1',
  year: 2017,
  content: [
    {
      type: 'image',
      images: [mosaic1Img]
    }
  ]
}

const projects = [
  project1,
]

const user = {
  username: 'brrck',
  name: 'Brock I.',
  url: 'https://www.instagram.com/b20roc/',
  avatar: profile,
  seen:false,
  anonymous: true,
  projects: projects
}

export default user



// WEBPACK FOOTER //
// ./src/Data/Users/brrck.js